import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { AuditServiceProvider } from '../../api/audit'

const AuditService = AuditServiceProvider()
const name = 'getAuditById'

export default (auditId) => (asyncAction(
  name,
  AuditService.getAuditById,
  { auditId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/audit/getAuditById.js